import React from "react";
class LeftNav extends React.Component {
  constructor(props){
    super(props);
    this.EXCLUSION_URLS = ['/','login'];
    this.state = {
      exists: true, //!this.EXCLUSION_URLS.includes('/'+location.href.split('?')[0].split('/').slice(3,1000).join('/')),
      mobile_open: false,
        tabs:{
            dashboard: {name: 'Dashboard', href:'/home', selected: false},
            customers: {name: 'Customers', href:'/s/customers', selected: false},
            invoices: {name: 'Invoices', href:'/s/invoices', selected: false},
            payments: {name: 'Payments', href:'/s/payments', selected: false},
            settings: {name: 'Settings', href:'/settings', selected: false}
        },
      urls:{
        '/home':['dashboard'],
        '/settings':['settings'],
        '/s/payments':['payments'],
        '/s/invoices':['invoices'],
        '/s/customers':['customers'],
        '/s/customers/:param':['customers'],
        '/s/payments/:param':['payments']
      }
    };

    this.URL_KEYWORDS = ['s','home','plans','new','index','dashboard','dashboards','template','developer','stripe','embed','credentials','customer','customers','invoice','root','templates','template','settings','payments','invoices'];

    this.toggle_mobile_nav = this.toggle_mobile_nav.bind(this);
    this.close_mobile_nav = this.close_mobile_nav.bind(this);
    this.handle_keydown = this.handle_keydown.bind(this);

  }

  componentDidMount(){
    /*if (this.EXCLUSION_URLS.includes('/'+location.href.split('?')[0].split('/').slice(3,1000).join('/'))){
        return null;
    }
    //document.getElementById('content').style.marginLeft = '210px';
    let tabs = this.state.tabs;
    const mod_pathname = window.location.pathname.split('/').map((x, i) => i === 0 ? '' : (!this.URL_KEYWORDS.includes(x) ? ':param' : x)).join('/'); // previously the test was x.length > 15
    console.log('mod_pathname');
    console.log(mod_pathname);
    let selected_tabs = this.state.urls[mod_pathname];
    if (selected_tabs === undefined){
      // lift state up to Header.js to remove this and... change header colour?
    } else {
      selected_tabs.forEach((tab) => tabs[tab].selected = true);
    }
    this.setState({
      tabs: tabs
    });*/
    if (this.EXCLUSION_URLS.includes(window.location.pathname)){
      this.setState({
        exists: false
      });
        return null;
    }
    //if (this.state.exists){
    //  document.getElementById('content').style.marginLeft = '250px';
    //}
    let tabs = this.state.tabs;
    const mod_pathname = window.location.pathname.split('/').map((x, i) => i === 0 ? '' : (!this.URL_KEYWORDS.includes(x) ? ':param' : x)).join('/'); // previously the test was x.length > 15
    console.log('mod_pathname');
    console.log(mod_pathname);
    let selected_tabs = this.state.urls[mod_pathname];
    if (selected_tabs === undefined){
      // lift state up to Header.js to remove this and... change header colour?
    } else {
      selected_tabs.forEach((tab) => tabs[tab].selected = true);
    }
    this.setState({
      tabs: tabs
    });

    this.mobile_toggle = document.getElementById('mobile-nav-toggle');
    if (this.mobile_toggle){
      this.mobile_toggle.addEventListener('click', this.toggle_mobile_nav);
    }
    document.addEventListener('keydown', this.handle_keydown);
  }

  componentWillUnmount(){
    if (this.mobile_toggle){
      this.mobile_toggle.removeEventListener('click', this.toggle_mobile_nav);
      this.mobile_toggle.setAttribute('aria-expanded', 'false');
    }
    document.removeEventListener('keydown', this.handle_keydown);
    document.getElementById('psintegril-sidebar')?.classList.remove('psintegril-sidebar-mobile-open');
  }

  toggle_mobile_nav(){
    this.setState((state) => ({mobile_open: !state.mobile_open}));
  }

  close_mobile_nav(){
    this.setState({mobile_open: false});
  }

  handle_keydown(event){
    if (event.key === 'Escape' && this.state.mobile_open){
      this.close_mobile_nav();
    }
  }

  componentDidUpdate(prevProps, prevState){
    if (prevState.mobile_open === this.state.mobile_open){
      return;
    }

    const sidebar = document.getElementById('psintegril-sidebar');
    if (sidebar){
      sidebar.classList.toggle('psintegril-sidebar-mobile-open', !!this.state.mobile_open);
    }
    if (this.mobile_toggle){
      this.mobile_toggle.setAttribute('aria-expanded', String(!!this.state.mobile_open));
    }
  }

  render(){
    console.log('LeftNav state:');
    console.log(this.state);
    return (this.state.exists ? 
      

        <nav className="psintegril-sidebar-nav">

            <button
                className="psintegril-mobile-nav-close"
                type="button"
                onClick={this.close_mobile_nav}
                aria-label="Close navigation menu">
                <span aria-hidden="true">×</span>
                <span>Close</span>
            </button>

            {Object.keys(this.state.tabs).map(
                (tab_name, index) => 
                <div
                    className={"psintegril-sidebar-link" + (this.state.tabs[tab_name].selected ? " psintegril-sidebar-link-active" : "")}
                    key={index}
                    onClick={() => window.location.href=this.state.tabs[tab_name].href}>
                    {this.state.tabs[tab_name].name}
                </div>
            )}

        </nav>

    : null)
  }
}

export default LeftNav
